import { Injectable } from '@angular/core';
import { CommandService } from './command.service';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class UniqueService extends CommandService {
  constructor() {
    super(new ToastController());
  }

  prepareCmd(cmd) {
    this.cmd = cmd;
  }

  sendMessage() {
    this.ble
      .write(
        this.device.bleId,
        this.device.serviceUUID,
        this.device.rxUUID,
        this.hexTobytes(this.cmd)
      )
      .then(
        (data) => {
          console.log('Cmd personnalisée : Cmd envoyée.');
        },
        (err) => {
          console.log(err);
        }
      );
  }

  public receiveResponse(data: any) {
    return this.buf2hex(data).toLowerCase();
  }
}
